<div class="offer-grid pr-xsmall-b" data-testid="offer-grid">
  @if (title()) {
    @switch (headerLevel()) {
      @case (1) {
        <h1 class="pr-xsmall-y" [ngClass]="{ 'pr-xsmall-y': !noHeaderPadding() }" data-testid="offer-grid-title">
          {{ title() }}
        </h1>
      }
      @case (2) {
        <h2 class="pr-xsmall-y" [ngClass]="{ 'pr-xsmall-y': !noHeaderPadding() }" data-testid="offer-grid-title">
          {{ title() }}
        </h2>
      }
      @case (3) {
        <h3 class="pr-xsmall-y" [ngClass]="{ 'pr-xsmall-y': !noHeaderPadding() }" data-testid="offer-grid-title">
          {{ title() }}
        </h3>
      }
      @case (4) {
        <h4 class="pr-xsmall-y" [ngClass]="{ 'pr-xsmall-y': !noHeaderPadding() }" data-testid="offer-grid-title">
          {{ title() }}
        </h4>
      }
      @default {
        <h3 class="pr-xsmall-y" [ngClass]="{ 'pr-xsmall-y': !noHeaderPadding() }" data-testid="offer-grid-title">
          {{ title() }}
        </h3>
      }
    }
  }
  @if (selectedOriginLocationName() && tripType()) {
    <p
      class="flex--self-center regular-type font-body-medium"
      [style]="cmsStylesOverride"
      [innerHTML]="'destinationSearch.flightsFrom' | finLocalization: { origin: selectedOriginLocationName() }"
      data-testid="offer-grid-trip-type-origin-label"
    ></p>
  }

  @if (offers()) {
    @if (isMobile() && mobileCarousel()) {
      <div class="ms-small-t">
        <fcom-carousel
          data-testid="offer-grid-carousel"
          [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
          [nextButtonAriaLabel]="'carousel.next' | finLocalization"
        >
          <div class="mobile-offers flex nowrap flex--middle flex--nowrap flex--align-stretch ps-medium-b">
            <ng-container [ngTemplateOutlet]="offersTemplate" />
          </div>
        </fcom-carousel>
      </div>
    } @else {
      <div class="offer-grid-offers fill grid-col-12 no-gutters" data-testid="offer-grid-offers-container">
        <ng-container [ngTemplateOutlet]="offersTemplate" />
      </div>
    }
  }

  <ng-template #offersTemplate>
    @for (offer of offers(); track offer.destination; let i = $index) {
      <fin-block-offer
        [tripType]="tripType()"
        [offer]="offer"
        [finScrolledPastThreshold]="1"
        (finScrolledPast)="scrolledPastDestination.emit({ offer: offer, index: i })"
        (destinationClicked)="destinationClick($event, i)"
        (flightHotelClicked)="emitFlightHotelClick($event, offer, i)"
        (calendarClicked)="emitCalendarClick($event, i)"
        [fetchImagePriority]="fetchImagePriority()"
        class="offer-grid-offer fill block flex slim"
      />
    }
  </ng-template>
</div>
